import { IntlShape, MessageDescriptor } from 'react-intl';

export const appendEmailBody = (
  intl: IntlShape,
  body: string,
  localizationKey: MessageDescriptor,
  value: Record<string, string | number> = {},
  endChar: string = '\n',
): string => {
  const line = intl.formatMessage(localizationKey, value);
  return `${body}${line}${endChar}`;
};

export const getLocation = (
  city: string | null,
  region: string | null,
  country: string | null,
): string => {
  let location = '';
  if (city !== null) {
    location += `${city}, `;
  }
  if (region !== null) {
    location += `${region}, `;
  }
  if (country !== null) {
    location += `${country}, `;
  }

  if (location !== '') {
    location = location.slice(0, -2);
  }
  return location;
};
